import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { FaSpinner } from 'react-icons/fa';

import { loadProductsByKeywords } from '../../../redux/modules/productsSearch';
import connectDataFetchers from '../../shared/lib/connectDataFetchers.js';

import A from '../../shared/Anchor/Anchor';
import LeftFilters from '../../shared/LeftFilters/LeftFilters';
import Breadcrumb from '../../shared/Breadcrumb/Breadcrumb';
import Pager from '../../shared/Pager/Pager';
import ProductThumbnail from '../../shared/ProductThumbnail/ProductThumbnail';

import { primary_dark15, primary_light } from '../../shared/lib/colors';

import '../Categoria/Categoria.scss';
import { css } from '@emotion/core';
import { pushRemarketingEvent } from '../../shared/lib/gaEnhancedEcommerce';
import IubendaCookieSolution from '../../../utils/iubenda';
import { ga4ViewItemList } from '../../shared/lib/ga4EnhancedEcommerce';
import { fkmxViewItemList } from '../../shared/lib/farmakomMetrics';
import { getSHA256Hash } from '../../../utils/sha256';
import { criteoViewList } from '../../shared/lib/criteo';
import { gtmToGa4ViewItemList } from '../../shared/lib/gtmEnhancedEcommerce.js';
import { cleanImage } from '../../../utils/images.js';

class Ricerca extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showFilters: false,
    };
  }

  componentDidMount() {
    if (this.props.hasCriteo) {
      //   const iubenda = new IubendaCookieSolution(
      //     this.props.hasIubendaCookieSolution
      //   );
      //   iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
      this.renderCriteoTag();
    }

    // REMARKETING DINAMICO
    if (this.props.hasDynamicRemarketing) {
      pushRemarketingEvent('searchresults');
    }

    // TRACK LIST - GTM, GA4, FKMX
    if (
      [
        this.props.hasGoogleTagManager,
        this.props.hasGoogleAnalytics4Advanced,
        this.props.hasFarmakomMetrics,
      ].some(t => !!t)
    ) {
      this.trackItemsList();
    }
  }

  componentDidUpdate(oldProps) {
    if (this.props.loading !== oldProps.loading && !this.props.loading) {
      if (this.props.hasCriteo) {
        // const iubenda = new IubendaCookieSolution(
        //   this.props.hasIubendaCookieSolution
        // );
        // iubenda.proceedIfHasConsent(() => this.renderCriteoTag());
        this.renderCriteoTag();
      }

      // REMARKETING DINAMICO
      if (this.props.hasDynamicRemarketing) {
        pushRemarketingEvent('searchresults');
      }

      // TRACK LIST - GTM, GA4, FKMX
      if (
        [
          this.props.hasGoogleTagManager,
          this.props.hasGoogleAnalytics4Advanced,
          this.props.hasFarmakomMetrics,
        ].some(t => !!t)
      ) {
        this.trackItemsList();
      }
    }
  }

  trackItemsList = () => {
    const { products } = this.props;

    const { keywords } = this.props.params;
    const ga4ListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };

    if (this.props.hasGoogleTagManager) {
      gtmToGa4ViewItemList(products, ga4ListInfo);
    }
    if (this.props.hasGoogleAnalytics4Advanced) {
      ga4ViewItemList(products, ga4ListInfo);
    }
    if (this.props.hasFarmakomMetrics) {
      fkmxViewItemList(products, ga4ListInfo);
    }
  };

  renderCriteoTag = async () => {
    // <!-- Criteo Category / Search / Listing Tag -->
    const email = (this.props.user && this.props.user.email) || '';
    const zipcode =
      (this.props.user &&
        this.props.user.shipping &&
        this.props.user.shipping.zipcode) ||
      '';
    criteoViewList(
      this.props.criteoAccountId,
      {
        email,
        zipcode,
      },
      this.props.products
    );
    // <!-- END Criteo Category / Search / Listing Tag -->
  };

  toggleFilters = event => {
    event.preventDefault();
    this.setState({
      showFilters: !this.state.showFilters,
    });
  };

  renderProducts() {
    const { isMobile } = this.props;
    return (
      <div style={{ width: '100%' }}>
        {!isMobile && (
          <div className={'desktop'}>{this.renderProductsDesktop()}</div>
        )}
        {isMobile && (
          <div className={'mobile'}>{this.renderProductsMobile()}</div>
        )}
      </div>
    );
  }

  renderProductsDesktop = () => {
    const { keywords } = this.props.params;
    const ga4ListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };

    return (
      <div className={'desktop-container'}>
        {this.props.products.map(product => {
          return (
            <div className="col-sm-6 col-lg-4" key={product.id}>
              <ProductThumbnail
                product={product}
                list="Ricerca"
                ga4ListInfo={ga4ListInfo}
              />
            </div>
          );
        })}
      </div>
    );
  };

  renderProductsMobile = () => {
    const { keywords } = this.props.params;
    const ga4ListInfo = {
      id: `ricerca_${keywords}`,
      name: `ricerca > ${keywords}`,
    };

    return (
      <div>
        <div className={'mobile-container'}>
          {this.props.products.map((product, index) => {
            return (
              <div style={{ width: '48%' }}>
                <ProductThumbnail
                  key={product.id}
                  product={product}
                  list="Ricerca"
                  spaceStar={6}
                  ga4ListInfo={ga4ListInfo}
                />
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  render() {
    const { showFilters } = this.state;
    const { keywords } = this.props.params;
    const {
      location,
      pagination,
      products,
      loading,
      siteName,
      logoImage,
      primaryColor,
      uiVariantButton,
    } = this.props;

    return (
      <div className={`categoria ${showFilters ? 'filters-open' : ''}`}>
        <Helmet
          title={`Risultati ricerca per ${keywords}`}
          meta={[
            {
              name: 'description',
              content: `${siteName} - Ecommerce Farmacia vendita ${keywords}`,
            },
            {
              name: 'keywords',
              content: `${keywords}, ecommerce, farmacia, ${siteName}`,
            },
            {
              property: 'og:title',
              content: `${siteName} - Ecommerce Farmacia vendita ${keywords}`,
            },
            { property: 'og:type', content: 'website' },
            {
              property: 'og:description',
              content: `${siteName} - Ecommerce Farmacia vendita online ${keywords}`,
            },
            { property: 'og:image', content: cleanImage(logoImage) },
          ]}
        />

        <div className="container">
          <LeftFilters
            location={location}
            sort={location.query.sort || 'sales'}
          />

          <div className="elenco-prodotti">
            <div className="pre-title">
              <A
                href="#"
                className="filter-toggle"
                onClick={this.toggleFilters}
              >
                {showFilters ? 'Nascondi filtri' : 'Mostra filtri'}
              </A>

              <Breadcrumb page="ricerca" keywords={keywords} />

              {products.length > 0 && (
                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  sort={location.query.sort || 'sales'}
                  primaryColor={primaryColor}
                  uiVariantButton={uiVariantButton}
                />
              )}
            </div>

            <div
              className="page-title"
              style={{
                color: primary_dark15(primaryColor),
                backgroundColor: primary_light(primaryColor),
                borderRadius:
                  uiVariantButton === '1'
                    ? '12px'
                    : uiVariantButton === '3'
                    ? '30px'
                    : 0,
              }}
            >
              Ricerca di {this.props.params.keywords}
              {loading && (
                <span className="pull-right">
                  <FaSpinner className="pulse" />
                </span>
              )}
            </div>

            {!loading && products.length > 0 && (
              <div>
                <div className="row">{this.renderProducts()}</div>

                <Pager
                  location={location}
                  page={location.query.page || 1}
                  totalPages={pagination.totalPages}
                  primaryColor={primaryColor}
                  isNew
                  uiVariantButton={uiVariantButton}
                />
              </div>
            )}

            {!loading && products.length === 0 && (
              <div className="no-results">
                <p>Nessun prodotto soddisfa i criteri di ricerca impostati.</p>
                <p>Prova con un termine più generico.</p>
              </div>
            )}
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isMobile: state.layout.isMobile,
    user: state.user.data,
    pagination: state.productsSearch.pagination,
    products: state.productsSearch.data,
    loading: state.productsSearch.loading,
    siteName: state.store.data.datiFarmacia.siteName,
    logoImage: state.store.data.loghiTemplate.logoImage,
    primaryColor: state.store.data.loghiTemplate.brandColor,
    uiVariantButton: state.store.data.uiVariants.buttons,
    hasCriteo: state.store.data.features.hasCriteo,
    hasDynamicRemarketing: state.store.data.features.hasDynamicRemarketing,
    criteoAccountId: state.store.data.integrazioni.criteo.accountId,
    hasIubendaCookieSolution:
      state.store.data.features.hasIubendaCookieSolution,
    hasGoogleAnalytics4Advanced: !!state.store.data.features
      .hasGoogleAnalytics4Advanced,
    hasGoogleTagManager: !!state.store.data.features.hasGoogleTagManager,
    hasFarmakomMetrics: !!state.store.data.integrazioni.metrics.apiKey,
  };
}

export default connect(mapStateToProps)(
  connectDataFetchers(Ricerca, [loadProductsByKeywords])
);
